import type { App } from 'vue'

import { i18n, setupI18n } from '@/shared/i18n'

/** Installs the vue-i18n runtime and returns the instance so the composition root can resolve
 *  keys outside a component (e.g. the http `onError` toast). `setupI18n` runs the locale
 *  detection/fallback chain and awaits the resolved locale's bundle before `app.use(i18n)`, so
 *  it is async — bootstrap awaits it (contract 04 §8). */
export async function installI18n(app: App): Promise<typeof i18n> {
  await setupI18n(app)
  return i18n
}
